import * as React from 'react';

export interface ConfirmProps {
  backgroundColor: string;
  color: string;
}

const ConfirmSvg = ({ backgroundColor, color }: ConfirmProps) => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
      <rect width="60" height="60" rx="30" fill={color} />
      <circle cx="30" cy="30" r="25" fill={color} stroke="black" stroke-width="2" />
      <path
        d="M30 56C26.3167 56 22.8933 55.3392 19.73 54.0175C16.5667 52.6958 13.815 50.865 11.475 48.525C9.135 46.185 7.30417 43.4333 5.9825 40.27C4.66083 37.1067 4 33.6833 4 30C4 26.36 4.66083 22.9583 5.9825 19.795C7.30417 16.6317 9.135 13.88 11.475 11.54C13.815 9.2 16.5667 7.35833 19.73 6.015C22.8933 4.67167 26.3167 4 30 4C33.64 4 37.0417 4.67167 40.205 6.015C43.3683 7.35833 46.12 9.2 48.46 11.54C50.8 13.88 52.6417 16.6317 53.985 19.795C55.3283 22.9583 56 26.36 56 30C56 33.6833 55.3283 37.1067 53.985 40.27C52.6417 43.4333 50.8 46.185 48.46 48.525C46.12 50.865 43.3683 52.6958 40.205 54.0175C37.0417 55.3392 33.64 56 30 56ZM26.165 41.83L44.56 23.435L41.57 20.51L26.165 35.915L18.365 28.115L15.44 31.04L26.165 41.83Z"
        fill={backgroundColor}
      />
    </svg>
  );
};

export default ConfirmSvg;
